import { getLiteral } from 'utils/getLiteral';
import { createSetMarketingConsentWithRowPatch } from './patchMarketingStatusRow';

export const NOOP_MARKETING_STATUS_CHANGE = () => {};

/** @returns {Promise<unknown>} */
export const NOOP_SET_MARKETING_CONSENT = () => Promise.resolve();

/**
 * Persists marketing status for one row (account or contact). Wired per entity list.
 * @typedef {object} SetMarketingConsentArgs
 * @property {number} id Entity id (account or contact).
 * @property {number} marketingStatusId tblMarketingStatus id.
 * @property {object} row Raw row data.
 */

export const getMarketingStatusColumn = ({
    hide = false,
    width,
    minWidth,
    /** Column key for field selector / saved views (must stay `marketingStatus` for filters). */
    colId = 'marketingStatus',
    /** Row field with tblMarketingStatus id — not the display label in `marketingStatus`. */
    field = 'marketingStatusId',
    fieldConfiguration = 'marketingStatus',
    onChange = NOOP_MARKETING_STATUS_CHANGE,
    /** @type {(args: SetMarketingConsentArgs) => Promise<unknown>} */
    setMarketingConsent = NOOP_SET_MARKETING_CONSENT,
    /** Entity constant (e.g. CONTACTS) — patches list row data after a successful status change. */
    entity,
    /** When true, cell shows status but does not open picker or persist changes (e.g. pickers modal). */
    isReadOnly = false,
} = {}) => {
    const persistMarketingConsent = createSetMarketingConsentWithRowPatch(
        setMarketingConsent,
        entity,
    );

    return {
        colId,
        headerName: getLiteral('label_marketing_status'),
        field,
        sortField: 'marketingStatusId',
        fieldConfiguration,
        cellRenderer: 'MarketingStatusCell',
        cellRendererParams: {
            onChange,
            setMarketingConsent: persistMarketingConsent,
            ...(isReadOnly ? { isReadOnly: true } : {}),
        },
        ...(typeof width === 'number' ? { width } : {}),
        ...(typeof minWidth === 'number' ? { minWidth } : {}),
        suppressSizeToFit: true,
        hide,
    };
};
